export default "__VITE_ASSET__45dsqjFC__"